export const LANG = 'ru';

export const USER_NAME_REGEX = '^[А-ЯЁа-яёA-Za-z\\-]{2,30}(\\s[А-ЯЁа-яёA-Za-z1-9\\-]+)?$';
export const SEARCH_WORD_REGEX = '^[А-ЯЁа-яёA-Za-z0-9\\s\\-]+$';

export const FULL_SIZE = 1024; 
export const DESCTOP = 800;
export const TABLET = 560;


export const FULL_SIZE_COUNT = 4;
export const DESCTOP_COUNT = 3;
export const TABLET_COUNT = 2;
export const MOBILE_COUNT = 1; 

export const REGULAR_ROW = 4;
export const MOBILE_ROW = 5;

export const SHORT_FILM = 40;